exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link>a[data-v-1e534fb9]{color:#fff;font-family:Raleway,sans-serif;font-weight:700}.container-fluid[data-v-1e534fb9]{width:90%}.footer[data-v-1e534fb9]{background-color:#000;padding-top:30px}.copyright[data-v-1e534fb9]{padding-top:5px;background-color:#fff;font-family:Raleway,sans-serif;font-size:11px;font-weight:700}.text-footer[data-v-1e534fb9]{text-align:center}@media only screen and (max-device-width:767.98px){.d-flex[data-v-1e534fb9]{margin-left:350px;width:45%!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e534fb9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer.vue
// module id = 317
// module chunks = 9